<template>
  <div class="page-report">
    <div class="img-bg"></div>
    <div class="report-top">
        <img src="@/assets/images/cartojourney/img09.png" class="bg-top" alt="">
        <div class="top-con">
            <div class="top-left">
                <div class="con-div">
                    <div class="label-div">
                        <img src="@/assets/images/cartojourney/img10.png" class="con-label" alt="">
                    </div>
                    <div class="con-val">房速; 典型房扑; 流出道室早室速; 阵发性房颤</div>
                </div>
                <div class="con-div">
                    <div class="label-div">
                        <img src="@/assets/images/cartojourney/img11.png" class="con-label con-label2" alt="">
                    </div>
                    <div class="con-val">压力技术(ST/STSF); 可调弯鞘; 心腔内超声; 三维可视多电极标测技术(Deca)</div>
                </div>
            </div>
            <img class="top-right" src="@/assets/images/cartojourney/img12.png" alt="">
        </div>
    </div>
    <div class="block-flex">
      <div
        class="flex-nav"
        v-for="(item, index) in detail.journeyReports"
        :key="index"
        @click="handleChangeJounery(item)"
        :class="
          item.journeyName === detail.currentJourneyStage.journeyName
            ? 'cur'
            : ''
        "
      >
        <div class="txt">{{ item && item.journeyName }}</div>
      </div>
    </div>
    <div class="block-info block-level">
      <van-collapse v-model="activeNames">
        <van-collapse-item
          class="level-item"
          v-for="(item, index) in curJourneyDetail.stages"
          :key="index"
          :class="
            detail.currentJourneyStage.currentStage &&
            item.stageName === detail.currentJourneyStage.currentStage.stageName
              ? 'cur_level'
              : ''
          "
          :name="index"
        >
          <template #title>
            <div class="col-title">
              <div class="state-name">
                {{
                  item.stageNo.substring(0, 2) === "U4"
                    ? "U3"
                    : item.stageNo.substring(0, 2)
                }}
              </div>
              <div class="state-title">{{ item && item.stageName }}</div>
              <div class="edit-btn">编辑</div>
            </div>
          </template>
          <div class="tip">
              <span class="time-txt">成长周期:2M</span>
            <span class="delay-day">
                毕业时间:2025-02-10
            </span>
          </div>
          <van-collapse class="level-course" v-model="activeCourse">
            <van-collapse-item
              title="学术活动"
              v-if="item.stageActivity && item.stageActivity.length > 0"
              :name="`${item.stageName}学术活动${index}`"
            >
                <div class="list-act">
                    <div class="item" v-for="(item_check, key_check) in item.stageActivity" :key="key_check">
                        <img src="@/assets/images/cartojourney/img16.png" class="item-cover" alt="">
                        <div class="item-cons">
                            <div class="cons-name">{{ item_check.activityName }}</div>
                            <div class="cons-flex">
                                <div class="flex-times">北京 2024.11</div>
                                <div class="status">已完成</div>
                            </div>
                        </div>
                    </div>
                </div>
            </van-collapse-item>
            <van-collapse-item
              title="iEP课程"
              v-if="item.stageCourses && item.stageCourses.length > 0"
              :name="`${item.stageName}课程学习${index}`"
            >
                <div class="list-act">
                    <div class="item" v-for="(item_check, key_check) in item.stageCourses" :key="key_check">
                        <img src="@/assets/12.png" class="item-cover course-cover" alt="">
                        <div class="item-cons">
                            <div class="cons-name">{{ item_check.courseDisplayName }}</div>
                            <div class="cons-flex">
                                <div class="flex-times">北京 2024.11</div>
                                <div class="status">已完成</div>
                                <!-- <div class="status none">未开始</div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </van-collapse-item>
          </van-collapse>
        </van-collapse-item>
      </van-collapse>
    </div>
    <barComponents v-if="isShowBar"></barComponents>
  </div>
</template>

<script>
import detailData from './index.json'
import { getJourneyReport } from '@/api/growthJourney.js'
import { xwzyJourneyReport } from '@/api/xwzy.js'
import { trackPageView } from '@/utils/trace'
import barComponents from '../../components/barComponents.vue'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  name: 'journeyReport',
  components: {
    barComponents,
  },
  data() {
    return {
      detail: {},
      activeNum: 0,
      activeNames: [0],
      cur_state: {},
      cur_journey_index: 0,
      curJourneyDetail: {},
      activeCourse: [],
      pathToFrom: {},
      isDouble: false,
      isShowBar: true,
      defaultTime: new Date().getTime(),
    }
  },
  mounted() {
    this.handleGetData()
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    // 跳转此页来源
    tabSource() {
      return this.$route.query.source || ''
    },
    // 跳转此页来源的医生multiCode
    tabMultiCode() {
      return this.$route.query.multiCode || ''
    },
    // 跳转此页来源的医生name
    tabDoctorName() {
      return this.$route.query.doctorName || ''
    },
  },
  destroyed() {},
  methods: {
    handleGetData() {
      let code = ''
      if (this.tabSource === 'growth-overview' || this.tabSource === 'xwzy') {
        code = this.tabMultiCode.toString()
      } else {
        code = this.userInfo.multiCode || ''
      }
      if (this.tabSource === 'xwzy') {
        xwzyJourneyReport({
          multiCode: this.code ? this.code : code,
        }).then((res) => {
          this.handleGetDataDefaut(res)
        })
        return
      }
      if (code) {
        getJourneyReport({
          multiCode: this.code ? this.code : code,
        }).then((res) => {
          this.handleGetDataDefaut(res)
        })
      } else {
        this.handleGetDataDefaut({ data: null })
      }
    },
    handleGetDataDefaut(res) {
      this.detail = res.data // || detailData 默认静态返回
      if (!this.detail && !this.boolReturn) {
        this.code = 'MULD100000793'
        this.boolReturn = true
        this.handleGetData()
        return
      } else if (!this.detail) {
        this.detail = detailData
      }
      // this.isDouble = (this.detail.currentJourneyNo === 'U' && this.detail.currentJourney === '超声视界之旅')
      let count = 0
      this.detail.journeyReports.map((res, index) => {
        if (res.learningStatus === '2') {
          count++
          this.cur_journey_index = index
          // 便利当前旅程下面的阶段赋值为2
          res.stages.map((itemStage, _index) => {
            if (itemStage.stageNo.substring(0, 2) !== 'U4') {
              if (itemStage.stageName === this.detail.currentStage) {
                itemStage.learningStatus = '2'
              }
            }
          })
        }
        this.isDouble = count === 2
      })
      this.detail.currentJourneyStage =
        this.detail.journeyReports[this.cur_journey_index]
      this.cur_state = this.detail.currentJourneyStage
      this.defaultState()
    },
    defaultState() {
      this.defaultTime = new Date().getTime()
      this.curJourneyDetail = this.detail.journeyReports.filter(
        (res, index) => {
          // 低于当前进行中的旅程的都视为已过关
          if (index < this.cur_journey_index) {
            if (
              (!this.isDouble && (index !== 1 || index !== 2)) ||
              index === 0
            ) {
              res.learningStatus = '1'
              res.stages.map((itemStage, _index) => {
                itemStage.learningStatus = '1'
              })
            }
          }
          // 如果是双旅程的话，当前最新旅程为进行中
          // if (this.isDouble && res.journeyName === this.detail.latestJourneyName) {
          //   res.learningStatus = '2'
          //   // 便利当前旅程下面的阶段赋值为2
          //   res.stages.map((itemStage, _index) => {
          //     itemStage.learningStatus = '3'
          //     if (itemStage.stageName === this.detail.latestStageName) {
          //       itemStage.learningStatus = '2'
          //     }
          //   })
          // }
          // 赋值低于当前阶段的都归为已过关
          let _i = 10
          for (let i = 0; i < res.stages.length; i++) {
            if (res.stages[i].stageNo.substring(0, 2) !== 'U4') {
              if (
                res.stages[i].learningStatus === '2' ||
                res.stages[i].learningStatus === '1'
              ) {
                _i = i
              }
              // if (i > _i && i !== 1) {
              if (i > _i) {
                res.stages[i].learningStatus = '1'
              }
            }
          }
          return (
            res.journeyName === this.detail.currentJourneyStage.journeyName
          )
        }
      )[0]
      this.curJourneyDetail.stages.map((res, index) => {
        res.stageTask1 = res.stageTasks.filter((res) => {
          return res.taskType === '病例复盘'
        })
        res.stageTask2 = res.stageTasks.filter((res) => {
          return res.taskType === '模拟器练习'
        })
        if (this.activeCourse.length > 0) {
          this.activeCourse = this.activeCourse.concat([
            `${res.stageName}病例复盘${index}`,
            `${res.stageName}学术活动${index}`,
            `${res.stageName}课程学习${index}`,
            `${res.stageName}模拟器练习${index}`,
          ])
        } else {
          this.activeCourse = [
            `${res.stageName}病例复盘${index}`,
            `${res.stageName}学术活动${index}`,
            `${res.stageName}课程学习${index}`,
            `${res.stageName}模拟器练习${index}`,
          ]
        }
        if (res.learningStatus === '2') {
          this.activeNames = [index]
          this.detail.currentJourneyStage.currentStage = res
        }
        return res
      })
      setTimeout(() => {
        window.sessionStorage.setItem(
          'traceTitle',
          `${'旅程报告-' + this.detail.currentJourneyStage.journeyName}`
        )
      })
    },
    // 选择切换旅程
    async handleChangeJounery(item) {
      window.sessionStorage.setItem(
        'traceTitle',
        `${'旅程报告-' + this.detail.currentJourneyStage.journeyName}`
      )
      await trackPageView(
        this.pathToFrom.to,
        this.pathToFrom.to,
        this.defaultTime
      ) // 上报数据
      this.activeNames = [100]
      this.detail.currentJourneyStage =
        this.cur_state.journeyName === item.journeyName ? this.cur_state : item
      this.detail.currentJourneyStage.stages.map((res) => {
        if (res.learningStatus === 2) {
          this.detail.currentJourneyStage.currentStage = res
        }
      })
      this.defaultState()
    },
  },
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.page-report {
  background-color: #f0f1f6;
  min-height: 100vh;
  padding-bottom: 60px;
  box-sizing: border-box;

.img-bg {
    width: 100%;
    background: linear-gradient( 180deg, #EB1700 0%, rgba(255, 226, 223, .2) 80%);
    height: 140px;
    position: fixed;
    left: 0;
    top: 0;
}
.report-top {
    position: relative;
    height: 155px;
    margin-bottom: 8px;
    padding: 0 10px;
    padding-top: 3px;
    box-sizing: border-box;
    .bg-top {
        width: calc(100% - 20px);
        position: absolute;
        left: 10px;
        top: 3px;
    }
    .top-con {
        display: flex;
        position: relative;
        padding-top: 43px;
        box-sizing: border-box;
        .top-left {
            display: flex;
            flex-direction: column;
            position: relative;
            ::after {
                position: absolute;
                right: 0;
                height: 100px;
                border-right: 1px solid rgba(0, 0, 0, 0.02);
                top: 0;
                content: '';
            }
            .con-div {
                display: flex;
                align-items: flex-start;
                .label-div {
                    width: 60px;
                    min-width: 60px;
                    max-width: 60px;
                    margin-right: 3px;
                    display: flex;
                    justify-content: flex-end;
                    .con-label {
                        width: 34px;
                        display: block;
                        &.con-label2 {
                            width: 45px;
                        }
                    }
                }
                .con-val {
                    font-family: Source Han Sans CN, Source Han Sans CN;
                    font-weight: 500;
                    font-size: 14px;
                    color: #000000;
                    line-height: 20px;
                    width: 234px;
                }
            }
        }
        .top-right {
            width: 26px;
            height: 84px;
            display: block;
            margin-left: 15px;
        }
    }
}

  .block-info {
    padding: 0 10px;
    box-sizing: border-box;
    margin-top: 12px;

    .title {
      font-size: 16px;
      color: #333333;
      font-weight: 600;
      padding-left: 15px;
      position: relative;
      margin-top: 16px;
      margin-bottom: 15px;

      &::before {
        position: absolute;
        left: 5px;
        width: 4px;
        height: 12px;
        border-radius: 4px;
        background-color: #EB1700;
        top: 50%;
        transform: translateY(-50%);
        content: "";
      }
    }

    .block-con {
      background-color: #fff;
      width: 100%;
      border-radius: 8px;
      padding: 17px 24px;
      padding-bottom: 1px;
      box-sizing: border-box;

      .con-info {
        display: flex;
        position: relative;
        margin-bottom: 16px;

        &::before {
          position: absolute;
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background-color: #d8d8d8;
          left: -10px;
          top: 7px;
          content: "";
        }

        .label {
          font-size: 12px;
          color: #333333;
          line-height: 17px;
          width: 120px;
        }

        .val {
          font-size: 12px;
          color: #333333;
          width: 200px;
          line-height: 17px;

          &.border {
            width: 58px;
            height: 17px;
            border-radius: 100px;
            border: 1px solid #EB1700;
            text-align: center;
          }
        }
      }
    }
  }

  .block-flex {
    display: flex;
    width: 100%;
    padding-left: 10px;
    box-sizing: border-box;
    overflow-y: auto;

    .flex-nav {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 8px;
      box-sizing: border-box;
      width: 90px;
      height: 62px;
      position: relative;
      background-image: url("../../assets/images/cartojourney/img14.png");
      background-size: 100% 100%;
      box-sizing: border-box;
      &.cur {
        height: 70px;
        background-image: url("../../assets/images/cartojourney/img13.png");
        .txt {
          color: #fff;
          position: relative;
          top: -2px;
        }
      }
      &:nth-last-child(1) {
        padding: 0 8px;
      }
      &:nth-child(1) {
        padding: 0 8px;
      }
      .txt {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 600;
        font-size: 14px;
        color: #eb1700;
        line-height: 16px;
        text-align: center;
      }
    }
  }

  .block-level {
    padding: 0 10px;
    padding-top: 0;
    box-sizing: border-box;

    /deep/ .level-item {
      padding: 16px 0;
      padding-left: 6px;
      padding-right: 12px;
      box-sizing: border-box;
      background-color: #fff;
      margin-bottom: 12px;
      border-radius: 8px;

      .van-cell {
        overflow: visible;
        &::after {
            border: none;
        }
        .van-icon-arrow {
            position: relative;
            top: 2px;
        }
      }

      .col-title {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 500;
        color: #000;

        .state-name {
          margin-right: 6px;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background: radial-gradient(
            circle at 32% 75%,
            #ff8274 0%,
            #eb1700 54%,
            #ffa69d 100%
          );
          color: #fff;
          text-align: center;
          line-height: 30px;
          font-weight: 500;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-size: 14px;
        }
        .state-title {
            flex: 1;
        }
        .edit-btn {
            width: 56px;
            text-align: center;
            border: 1px solid #EB1700;
            border-radius: 100px;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-size: 14px;
            font-weight: 400;
            height: 22px;
            line-height: 22px;
            color: #EB1700;
            margin-right: 4px;
        }
      }

      .van-collapse-item__wrapper {
        padding-left: 34px;
        box-sizing: border-box;
      }

      &::before {
        position: absolute;
        left: 21px;
        border-left: 1px dashed #979797;
        content: "";
        height: calc(100% - 56px);
        top: 40px;
        transform: inherit;
      }

      /deep/ .van-cell__title {
        font-size: 16px;
        color: #000;
        font-weight: 500;
      }

      .level-title {
        display: flex;
        font-size: 12px;
        color: #333333;
        margin-top: 9px;
        margin-bottom: 15px;

        .level-txt {
          margin-right: 10px;

          .img-txt {
            width: 53px;
            height: 19px;
          }
        }

        .icon-title {
          width: 53px;
          height: 20px;
          margin-right: 3px;
        }
      }

      .tip {
        font-size: 12px;
        color: #EB1700;
        margin: 6px 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
      }

      .level-course {
        border-radius: 2px;
        position: relative;

        .van-cell__title {
          font-size: 12px;
          color: #333333;
        }

        .van-cell {
          background: transparent;
        }

        .van-collapse-item__wrapper {
          padding-left: 0;
        }

        .van-collapse-item {
          margin-bottom: 8px;
          padding: 6px;
          padding-bottom: 12px;
          box-sizing: border-box;
          z-index: 9;

          &::before {
            background: linear-gradient(
              270deg,
              rgba(171, 172, 204, 0.14) 0%,
              #abaccc 100%
            );
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0.17;
            z-index: -1;
            content: "";
          }

          &::after {
            border: none;
          }

          &:nth-last-child(1) {
            margin-bottom: 0;
          }

          .van-collapse-item__content {
            background: transparent;
          }
        }
        .list-act {
            max-height: 320px;
            overflow-y: scroll;
            .item {
                display: flex;
                align-items: center;
                padding: 8px 4px;
                box-sizing: border-box;
                background-color: #fff;
                border-radius: 4px;
                margin-top: 8px;
                .item-cover {
                    width: 32px;
                    height: 32px;
                    display: block;
                    margin-right: 2px;
                    &.course-cover {
                        width: 72px;
                        height: 40px;
                        object-fit: cover;
                    }
                }
                .item-cons {
                    display: flex;
                    flex-direction: column;
                    flex: 1;
                    .cons-name {
                        font-family: PingFang HK, PingFang HK;
                        font-weight: 500;
                        font-size: 13px;
                        color: #000000;
                    }
                    .cons-flex {
                        display: flex;
                        justify-content: space-between;
                        flex: 1;
                        height: 20px;
                        .flex-times {
                            font-family: Source Han Sans CN, Source Han Sans CN;
                            font-size: 13px;
                            color: #B1B1B1;
                        }
                        .status {
                            font-family: Source Han Sans CN, Source Han Sans CN;
                            font-size: 12px;
                            color: #EB1700;
                            &.none {
                                background-color: #EB1700;
                                color: #fff;
                                text-align: center;
                                width: 46px;
                                border-radius: 100px;
                            }
                        }
                    }
                }
            }
        }
      }
    }
  }
}

/deep/ .van-cell {
  padding: 0;
}

/deep/ .van-collapse-item__content {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/cartoJourney/journeyPage copy.vue